import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty, isNil } from 'lodash-es';
import { Observable } from 'rxjs';

/**
 * Takes in a vimeo image url, and returns aspect ratio
 */
@Pipe({
  name: 'vimeoAspectRatio',
  pure: true
})
export class vimeoAspectRatio implements PipeTransform {

  transform(photoUrl: string): number {
    const matches = new RegExp(/\d*x\d*/).exec(photoUrl);

    if (isEmpty(matches) || isNil(matches)) {
      // Correct aspect ratio for most videos is 16:9
      return 16/9;
    }

    // This will be a string that looks like this 1280x720
    const [match] = matches;

    const [width, height] = match.split('x');

    const parsedWidth = parseInt(width, 10);
    const parsedHeight = parseInt(height, 10);

    const aspectRatio = parsedWidth / parsedHeight;

    return aspectRatio;
  }

}
